import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { Form, Icon, Input, Button, Upload, Select, message, notification } from 'antd';
import { loginUser } from '../../Redux/actions/authActions'
import country from '../../country'
import logo from '../../assets/pantrylogo.png'
import Footer from '../../Components/Footer'
import axios from 'axios'
import { serverUrl } from '../../Config/api'

const title = "Error"


const { Option } = Select
const { Dragger } = Upload

function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
}

const props = {
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    listType: 'picture',
    accept: "image/*",
};

class Account extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            fileList: [],
            disableUpload: false,
            userGroup: [],
            disable: false,
            loading: false
        }
    }

    componentDidMount() {
        const { user, form } = this.props
        const { fileList } = this.state
        const { setFieldsValue } = form
        let image = {}
        if (!user || user.role !== 'admin') {
            this.props.history.replace('/login')
        }
        else if (user && user.avatar) {
            image.name = `${user.avatar.public_id}.${user.avatar.format}`
            image.thumbUrl = user.avatar.url
            image.uid = user._id
            fileList.push(image)
            this.setState({ fileList })
        }
        setFieldsValue({ ...user, avatar: image })
    }

    normFile = e => {
        this.setState({ disableUpload: false })
        if (e.file.type && e.file.type.indexOf('image')) {
            // this.openNotification(title, 'Please Upload an Image', 'close-circle', 'red')
            return
        }
        if (Array.isArray(e)) {
            return e;
        }
        if (e.fileList.length) {
            this.setState({ disableUpload: true, fileList: e.fileList })
        }
        return e && e.fileList;
    }

    openNotification = (title, desc, icon, color = '#108ee9') => {
        notification.open({
            message: title,
            description: desc,
            icon: <Icon type={icon} style={{ color: color }} />,
        });
    };

    handleSubmit = e => {
        const { user, form } = this.props
        const { validateFields } = form
        e.preventDefault();
        validateFields((err, values) => {
            if (!err) {
                this.setState({ disable: true, loading: true })
                let formData = new FormData();
                for (var i in values) {
                    if (values[i]) {
                        formData.append(i, values[i])
                    }
                }
                formData.append('_id', user._id)
                if (values.avatar.file) {
                    formData.set('avatar', values.avatar.fileList[0].originFileObj)
                }
                else {
                    formData.delete('avatar')
                }
                axios.post(`${serverUrl}/admin/user/update-account`, formData)
                    .then((result) => {
                        const { data } = result
                        if (data.success) {
                            this.openNotification('Success', data.message, 'check')
                            this.props.loginUser(data.data)
                            setTimeout(() => {
                                this.setState({ disable: false, loading: false })
                                this.props.history.replace('/')
                            }, 500)
                        }
                        else {
                            this.openNotification(title, data.message, 'close-circle', 'red')
                            this.setState({ disable: false, loading: false })
                        }
                    })
                    .catch((err) => {
                        this.openNotification(title, "OOPS Something went wrong!!!", 'close-circle', 'red')
                        this.setState({ disable: false, loading: false })
                    })
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { disableUpload, userGroup, disable, loading } = this.state
        return (
            <div>
                <div className="advertisement2">
                </div>


                <header className="header2 bg-light">
                    <nav className="navbar  navbar-light">
                        <div className="container">
                            <Link className="navbar-brand" to="/"><img src={logo} alt="logo" className="img-fluid" /></Link>
                            <div style={{ display: 'flex' }}>
                                <Link className="home-btn" to="/"><i className="fas fa-home"></i></Link>
                                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsingNavbar">
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                            </div>
                            <div className="collapse navbar-collapse" id="collapsingNavbar">
                                <ul className="navbar-nav ml-auto">
                                    <li className="nav-item"><Link className="nav-link" to="/">Home</Link> </li>
                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Settings
                                        </a>
                                        <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                            <a className="nav-link dropdown-toggle nav-link-child" href="#" id="navbarDropdownChild" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Delivery
                                            </a>
                                            <div className="dropdown-menu" aria-labelledby="navbarDropdownChild">
                                                <Link className="dropdown-item" to="/timeslot">TimeSlot</Link>
                                                <Link className="dropdown-item" to="/region">Region</Link>
                                                <Link className="dropdown-item" to="/costs">Costs</Link>
                                            </div>
                                            <Link className="dropdown-item" to="/grocery">Grocery</Link>
                                            <Link className="dropdown-item" to="/offer-type">OfferType</Link>
                                            <Link className="dropdown-item" to="/topic">Topic</Link>
                                            <Link className="dropdown-item" to="/user-group">UserGroup</Link>
                                            <Link className="dropdown-item" to="/product">Product</Link>
                                            <Link className="dropdown-item" to="/product-group">ProductGroup</Link>
                                            <Link className="dropdown-item" to="/product-type">ProductType</Link>
                                            <Link className="dropdown-item" to="/qanda">Question & Answer settings </Link>
                                            <Link className="dropdown-item" to="/focusgroup">Focusgroup settings</Link>
                                            <Link className="dropdown-item" to="/1to1">1 To 1 Offer settings</Link>
                                            <Link className="dropdown-item" to="/ad">Promotional Ads settings</Link>
                                            <Link className="dropdown-item" to="/faq">FAQ</Link>
                                        </div>
                                    </li>
                                    <li className="nav-item"><Link className="nav-link" to="/subscription">Subscriptions</Link> </li>
                                    <li className="nav-item"><Link className="nav-link" to="/insight">Insights</Link> </li>
                                    <li className="nav-item"><Link className="nav-link" to="/invoice">Invoices</Link> </li><li className="nav-item"><Link className="nav-link" to="/login">Logout</Link> </li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                </header>

                <section className="main-content-bg2">
                    <div className="center1">
                        <div className="card2">
                            <Form
                                className="login-form form-w"
                                hideRequiredMark={true}
                                onSubmit={this.handleSubmit}
                                encType="multipart/form-data">
                                <h1 className="heading1" >ACCOUNT SETTINGS</h1>
                                <Form.Item
                                    label="User Name"
                                >
                                    {getFieldDecorator('userName', {
                                        rules: [{ required: true, message: 'Please input Name!' }],
                                    })(
                                        <Input
                                            type="text"
                                            minLength={3}
                                            placeholder="Name"
                                        />,
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label="Email"
                                >
                                    {getFieldDecorator('email', {
                                        rules: [{ required: true, message: 'Please input Email!' }],
                                    })(
                                        <Input
                                            type="email"
                                            minLength={3}
                                            placeholder="Email"
                                            disabled
                                        />,
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label="Surname"
                                >
                                    {getFieldDecorator('surName', {
                                        rules: [{ message: 'Please input Surname Name!' }],
                                    })(
                                        <Input
                                            type="text"
                                            minLength={3}
                                            placeholder="Surname"
                                        />,
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label="Telno"
                                >
                                    {getFieldDecorator('telNo', {
                                        rules: [{ message: 'Please input Telno!!' }],
                                    })(
                                        <Input
                                            type="number"
                                            minLength={3}
                                            placeholder="Telno"
                                        />,
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label="Postal Code"
                                >
                                    {getFieldDecorator('postalCode', {
                                        rules: [{ message: 'Please input Postal Code!' }],
                                    })(
                                        <Input
                                            type="text"
                                            minLength={3}
                                            placeholder="Postal Code"
                                        />,
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label="House No"
                                >
                                    {getFieldDecorator('houseNo', {
                                        rules: [{ message: 'Please input House No!' }],
                                    })(
                                        <Input
                                            type="number"
                                            placeholder="House No"
                                        />,
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label="House No extra info"
                                >
                                    {getFieldDecorator('houseNoExtra', {
                                        rules: [{ message: 'Please input House No extra info!' }],
                                    })(
                                        <Input type="text" placeholder="House No extra info!!!" />,
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label="City"
                                >
                                    {getFieldDecorator('city', {
                                        rules: [{ message: 'Please input City!' }],
                                    })(
                                        <Input type="text" placeholder="City!!!" />,
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label="Upload Image"
                                >
                                    {getFieldDecorator('avatar', {
                                        rules: [{ required: true, message: 'Please upload Image!' }],
                                    })(
                                        <Upload
                                            {...props}
                                            fileList={this.state.fileList}
                                            onRemove={() => this.setState({ fileList: [] })}
                                            onChange={this.normFile}
                                            beforeUpload={beforeUpload}
                                        >
                                            <Button disabled={this.state.fileList.length ? true : false}>
                                                <Icon type="upload" /> Upload Avatar
                                                </Button>
                                        </Upload>,
                                    )}
                                </Form.Item>
                                <Form.Item>
                                    <div className="submit-btn">
                                        <Button disabled={disable} loading={loading} htmlType="submit" className="btn" style={{ backgroundColor: '#0587EF', color: 'white', fontWeight: 'bold', fontSize: 14, height: 50, display: 'flex', width: '100%', textAlign: 'center', justifyContent: 'center', alignItems: 'center', boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)' }}>
                                            Save
                                        </Button>
                                    </div>
                                </Form.Item>
                            </Form>
                            <br />

                            {/* <Form
                                className="login-form"
                                hideRequiredMark={true}
                                encType="multipart/form-data">
                                <h1 className="heading1" >CHANGE PASSWORD</h1>
                                <Form.Item
                                    label="Current Password"
                                >
                                    {getFieldDecorator('curentPass', {
                                        rules: [{ required: true, message: 'Please input Current Password!' }],
                                    })(
                                        <Input.Password placeholder="Current Password" />,
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label="New Password"
                                >
                                    {getFieldDecorator('newPass', {
                                        rules: [{ required: true, message: 'Please New Password!' }],
                                    })(
                                        <Input.Password placeholder="New Password!!!" />,
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label="Confirm"
                                >
                                    {getFieldDecorator('confirmPass', {
                                        rules: [{ required: true, message: 'Please input Password!' }],
                                    })(
                                        <Input.Password placeholder="Confirm New Password!!!" />,
                                    )}
                                </Form.Item>
                                <Form.Item>
                                    <div className="submit-btn">
                                        <Button htmlType="submit" className="btn" style={{ backgroundColor: '#0587EF', color: 'white', fontWeight: 'bold', fontSize: 14, height: 50, display: 'flex', width: '100%', textAlign: 'center', justifyContent: 'center', alignItems: 'center', boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)' }}>
                                            Adjust
                                        </Button>
                                    </div>
                                </Form.Item>
                            </Form> */}
                        </div>
                    </div>
                </section>



                <Footer {...this.props} />
            </div>
        )
    }
}


const AccountForm = Form.create({ name: 'normal_login' })(Account);

const mapStateToProps = (state) => {
    return {
        user: state.authReducer.user,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        loginUser: (user) => dispatch(loginUser(user)),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(AccountForm)